import Icon, { InfoIcon } from '@design-systems/react-icons'
import DraftReviewView from './DraftReviewView'
import ExtractionProgressView from './ExtractionProgressView'
import { DRAFTS_SCREEN } from '../helpers/draftsScreenHelpers'

// The Drafts tab has five faces. Which one is shown is decided from the
// brand's lifecycle status before this renders — see getDraftsScreen.
const ReviewDraftsView = ({
  extractionError = '',
  isExtracting = false,
  isReadOnly = false,
  isSaving = false,
  onApproveGroup,
  onDiscard,
  onEditApprovedGroup,
  onEditGroup,
  onResolveSection,
  onRetryExtraction,
  onUndoGroup,
  progressItems = [],
  review,
  reviewError = '',
  screen = DRAFTS_SCREEN.EMPTY,
}) => {
  if (screen === DRAFTS_SCREEN.EMPTY || screen === DRAFTS_SCREEN.ACTIVE) {
    return (
      <section aria-label="Drafts" className="draft-review">
        <div className="upload-documents__notice">
          <Icon size="lg" svg={InfoIcon} />
          <span>
            <span>
              {screen === DRAFTS_SCREEN.ACTIVE
                ? 'No drafts. This brand is live — its sections are on the Brand Profile tab.'
                : 'No drafts yet. Upload the required documents, then run AI extraction to generate sections for review.'}
            </span>
          </span>
        </div>
      </section>
    )
  }

  if (screen === DRAFTS_SCREEN.PROGRESS) {
    return (
      <ExtractionProgressView
        error={extractionError}
        isExtracting={isExtracting}
        items={progressItems}
        onDiscard={onDiscard}
        onRetry={onRetryExtraction}
      />
    )
  }

  if (screen === DRAFTS_SCREEN.LOADING) {
    return (
      <section aria-label="Review extracted sections" className="draft-review">
        <p className="draft-review__empty">Loading extracted sections…</p>
      </section>
    )
  }

  return (
    <DraftReviewView
      error={reviewError}
      isReadOnly={isReadOnly}
      isSaving={isSaving}
      onApproveGroup={onApproveGroup}
      onEditApprovedGroup={onEditApprovedGroup}
      onEditGroup={onEditGroup}
      onResolveSection={onResolveSection}
      onUndoGroup={onUndoGroup}
      review={review}
    />
  )
}

export default ReviewDraftsView
